import type { Component, ComponentType, FunctionComponent } from 'react';

/**
 * Type guards that have nothing to do with Sure business logic.
 * JS constructors, DOM objects, etc.
 */

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function isNumber(value: any): value is number {
  return typeof value === 'number';
}

export function isDateConstructorArg(
  value: any
): value is string | number | Date {
  return isString(value) || isNumber(value) || value instanceof Date;
}

export function isFunction(value: any): value is string {
  return typeof value === 'function';
}

function isReactClassComponent(value: any): value is Component {
  return 'render' in value && isFunction(value.render);
}

function isReactFunctionComponent(value: any): value is FunctionComponent {
  return isFunction(value);
}

export function isReactComponent(value: any): value is ComponentType {
  return isReactClassComponent(value) || isReactFunctionComponent(value);
}
